<template>
    <section id="section" class="cb">
        <div class="tab-lists-container">
            <div class="tab-title-container">
                <div class="tab-m-title-container">
                    <i class="icon-user"></i>
                    <span class="tab-m-title">个人中心</span>
                </div>
            </div>
            <div class="tab-border-container">
                <div class="tab-s-border"></div>
                <div class="tab-m-border"></div>
            </div>
        </div>
        <div class="nav fl">
            <router-link to="/users" class="li" exact>
                <i class="icon-home"></i>
                <span>首<span class="op">首页</span>页</span>
            </router-link>

            <router-link to="/users/update" class="li" exact>
                <i class="icon-information"></i>
                <span>我的信息</span>
            </router-link>

            <router-link to="/users/avatar" class="li" exact>
                <i class="icon-avatar"></i>
                <span>我的头像</span>
            </router-link>
            <!--<router-link to="/user/collect" class="li">
                <i class="icon-collected"></i>
                <span>我的收藏</span>
            </router-link>-->

            <!--<router-link to="/user/follow" class="li">
                <i class="icon-liked"></i>
                <span>我的关注</span>
            </router-link>-->

            <details class="li">
                <summary>
                    <span>创作中心</span>
                    <i class="icon-b-arrow"></i>
                </summary>
            </details>

            <div>
                <router-link to="/users/upload" exact class="pane">
                    <i class="icon-r-arrow"></i>
                    上传视频
                </router-link>
                <router-link to="/users/manage" class="pane">
                    <i class="icon-r-arrow"></i>
                    视频管理
                </router-link>
                <router-link to="/users/upload/norm" class="pane">
                    <i class="icon-r-arrow"></i>
                    投稿规范
                </router-link>
            </div>
        </div>
        <router-view v-if="is_reload" @reload="reload" class="r-box pr fl"></router-view>
    </section>
</template>

<script>
    export default {
        data: () => ({
            is_reload: true
        }),
        methods: {
            reload() {
                this.is_reload = false;
                this.$nextTick(() => {
                    this.is_reload = true;
                })
            }
        },
        computed: {
            user() {
                return this.$store.state.user.id;
            }
        },
        watch: {
            user() {
                if (!this.user) this.$router.push('/');
            }
        },
        beforeCreate() {
            let {user} = this.$store.state;
            !user.id && this.$router.push('/');
            this.api.get('users/info').then(e => {
                for (let k in e) {
                    user[k] = e[k];
                }
                window.localStorage.user = JSON.stringify(user);// 存入localStorage
            }, () => {
                this.alert.err('获取用户信息失败, 请尝试刷新页面');
            });
        }
    }
</script>

<style scoped>
    @import "../../../static/css/views/user/nav.css";
</style>



// WEBPACK FOOTER //
// src/views/user/Nav.vue